export default function BackButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="w-full py-2 bg-gray-100 rounded-xl"
    >
      ← Back
    </button>
  );
}